module.exports = __webpack_public_path__ + "static/img/sns.5448116.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sns.jpg
// module id = AWqM
// module chunks = 1